
<template>
  <div class="knd-intro" :class="className"> 
    <div class="">
      <VideoPart 
        :poster="undefined"
        :controls="false"
        :loop="true"
        :description="''"
        :autoplay="true"
        :src="getVideo('231012_collage_00_Opening-update.mp4')" 
        class="m-b-xl"
      />
    </div>
    <div class="knd-paragraaf">
      <div v-html="tekst"></div>
    </div>

    <Pijl />


  </div>
</template>

<script>
import { ref } from 'vue';
import VideoPart from '@/components/video';
import Pijl from '@/components/pijl';

export default {
  props: {
    tekst:{
      type: String
    }
  },
  components:{VideoPart, Pijl},
  setup() {
    const count = ref(0);
    let className = ref('mobile');

    function getVideo(name) {

      var w = window.innerWidth;
      let n = name;
      if(w > 680) {
        n = "231113-MisinfoQuiz-Opening-Desktop.mp4";
        className.value = 'desktop'
      }

      return require('@/assets/video/' + n);
    }

    // expose to template and other options API hooks
    return {
      count,
      getVideo,
      className
    }
  }
}
</script>

<style lang="scss">
  .knd-intro {
    background: #CBFFE6;

    video {
      max-width: var(--knd-max-width);
    }

    &.desktop {
      video {
        max-width: 1280px;
      }
    }
  }
</style>